import axios from 'axios'
import configLoader from '../config/loader'

interface ClientOption {
  baseURL: string
  timeout: number
  headers: any
}

export default class RequestService {
  baseUrl: any

  private static instanceMap = new Map<string, RequestService>()

  static Instance(defaultType?: string): RequestService {
    const serverConfig = configLoader.loadServerConfig()
    let type = 'default'
    if (defaultType) {
      type = defaultType
    }

    if (this.instanceMap.has(type)) {
      return this.instanceMap.get(type)
    }

    const instance = new RequestService(`${serverConfig.protocol || 'https'}://${serverConfig.host}`)
    this.instanceMap.set(type, instance)
    return instance
  }

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
  }

  getClient(token?: string) {
    const options: ClientOption = {
      baseURL: this.baseUrl,
      timeout: 10000,
      headers: {},
    }
    if (token) {
      options.headers['authorization'] = token
    }
    return axios.create(options)
  }

  setBaseUrl(baseUrl: string) {
    this.baseUrl = baseUrl
  }
}
